export const NUMBER_OF_SUGGESTED_FRIENDS_TO_SHOW = 14
